"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTracking = require("react-tracking");

var _iconGlobe = _interopRequireDefault(require("../../images/icon-globe.svg"));

var _iconTriangleDownBlack = _interopRequireDefault(require("../../images/icon-triangle-down-black.svg"));

var _stitches = require("../../stitches.config");

var _offline = require("../../utilities/offline");

var LocaleSelectContainer = (0, _stitches.styled)('div', {
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto',
  img: {
    marginRight: '5px'
  },
  '@desktop': {
    flexBasis: '22%',
    justifyContent: 'flex-end',
    marginLeft: '10px'
  }
});
var StyledLocaleSelect = (0, _stitches.styled)('select', {
  appearance: 'none',
  background: "transparent url(".concat(_iconTriangleDownBlack.default, ") no-repeat 95% 50%"),
  border: 'none',
  color: '$black',
  cursor: 'pointer',
  fontSize: '$xSmall',
  textDecoration: 'underline'
});
/**
 * A locale select component that also notifies the user when they are offline.
 */

var LocaleSelect = function LocaleSelect(_ref) {
  var i18n = _ref.i18n;

  var _useTracking = (0, _reactTracking.useTracking)(),
      trackEvent = _useTracking.trackEvent;

  var showModalIfOffline = (0, _offline.handleOffline)(function () {
    return console.log('you are offline');
  }); // eslint-disable-line no-console

  /**
   * Use a temporary select and option filled with the selected option text to
   * set the locale-select's width
   */

  var setSelectSize = function setSelectSize() {
    var select = document.getElementById('locale-select');
    var tempSelect = document.createElement('select');
    var tempOption = document.createElement('option');
    tempOption.textContent = select.options[select.selectedIndex].text;
    tempSelect.style = 'visibility: none;';
    tempSelect.appendChild(tempOption);
    select.after(tempSelect);
    var tempSelectWidth = tempSelect.getBoundingClientRect().width;
    select.style.width = "".concat(tempSelectWidth - 7, "px");
    tempSelect.remove();
  };

  var handleLocaleChange = function handleLocaleChange(event) {
    var ifOnline = function ifOnline() {
      var select = event.target;
      var newLocale = select.options[select.selectedIndex].value;
      trackEvent({
        event_name: 'locale-selected',
        newLocale: newLocale,
        oldLocale: i18n.language
      });
      i18n.changeLocale(newLocale);
      setSelectSize();
    };

    showModalIfOffline(ifOnline);
  };

  (0, _react.useEffect)(function () {
    // Set the inital language on load properly
    i18n.changeLocale(i18n.language);
    setSelectSize();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react.default.createElement(LocaleSelectContainer, null, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Globe Icon",
    src: _iconGlobe.default
  }), /*#__PURE__*/_react.default.createElement(StyledLocaleSelect, {
    "aria-label": "Locale",
    id: "locale-select",
    name: "locale",
    value: i18n.language,
    onChange: handleLocaleChange
  }, i18n.locales.map(function (locale) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: locale.value,
      value: locale.value
    }, locale.display);
  })));
};

LocaleSelect.defaultProps = {};
var _default = LocaleSelect;
exports.default = _default;